module.exports = __webpack_public_path__ + "assets/31599c618547e2e57f22a1d7e6c79049.mp3";